

















import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';

@Component
export default class SwDragOverlay extends SwExtendedVue {
  @Prop({ type: String, required: true })
  id: string;
}
